export default "__VITE_ASSET__DeW0xCn6__"